export default __webpack_public_path__ + "static/media/tick-icon.4d4e3861.svg";